/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputDuplicateDivision
 */
export interface OutputDuplicateDivision {
    /**
     * 
     * @type {number}
     * @memberof OutputDuplicateDivision
     */
    d1Id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputDuplicateDivision
     */
    d1Name?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDuplicateDivision
     */
    d1Teams?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDuplicateDivision
     */
    d1Zones?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputDuplicateDivision
     */
    d2Id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputDuplicateDivision
     */
    d2Name?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDuplicateDivision
     */
    d2Teams?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDuplicateDivision
     */
    d2Zones?: string;
}

/**
 * Check if a given object implements the OutputDuplicateDivision interface.
 */
export function instanceOfOutputDuplicateDivision(value: object): boolean {
    return true;
}

export function OutputDuplicateDivisionFromJSON(json: any): OutputDuplicateDivision {
    return OutputDuplicateDivisionFromJSONTyped(json, false);
}

export function OutputDuplicateDivisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputDuplicateDivision {
    if (json == null) {
        return json;
    }
    return {
        
        'd1Id': json['d1Id'] == null ? undefined : json['d1Id'],
        'd1Name': json['d1Name'] == null ? undefined : json['d1Name'],
        'd1Teams': json['d1Teams'] == null ? undefined : json['d1Teams'],
        'd1Zones': json['d1Zones'] == null ? undefined : json['d1Zones'],
        'd2Id': json['d2Id'] == null ? undefined : json['d2Id'],
        'd2Name': json['d2Name'] == null ? undefined : json['d2Name'],
        'd2Teams': json['d2Teams'] == null ? undefined : json['d2Teams'],
        'd2Zones': json['d2Zones'] == null ? undefined : json['d2Zones'],
    };
}

export function OutputDuplicateDivisionToJSON(value?: OutputDuplicateDivision | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'd1Id': value['d1Id'],
        'd1Name': value['d1Name'],
        'd1Teams': value['d1Teams'],
        'd1Zones': value['d1Zones'],
        'd2Id': value['d2Id'],
        'd2Name': value['d2Name'],
        'd2Teams': value['d2Teams'],
        'd2Zones': value['d2Zones'],
    };
}

